import { getSupabaseClient } from '../../lib/supabase'

export async function getAmigoUsage(organizationId: string) {
  const supabase = getSupabaseClient()
  const { data: summaryRows, error: summaryError } = await supabase.rpc(
    'get_amigo_usage_dashboard',
    { target_organization_id: organizationId },
  )
  if (summaryError) throw summaryError

  const { data: events, error: eventsError } = await supabase
    .from('amigo_usage_events')
    .select('id,status,model,input_tokens,output_tokens,estimated_cost_microusd,error_code,created_at')
    .eq('organization_id', organizationId)
    .order('created_at', { ascending: false })
    .limit(20)
  if (eventsError) throw eventsError

  const summary = summaryRows?.[0]
  if (!summary) throw new Error('Amigo usage summary is unavailable.')
  return { summary, events }
}

export function percentage(value: number, limit: number) {
  if (limit <= 0) return 0
  return Math.min(100, Math.round((value / limit) * 100))
}

export function dollars(microusd: number) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 4 }).format(microusd / 1_000_000)
}
